import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\GetCommissionNoteHeadersController::__invoke
* @see app/Http/Controllers/CommissionNote/GetCommissionNoteHeadersController.php
* @route '/api/commission-note/{commission_note}/headers'
*/
const GetCommissionNoteHeadersController = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCommissionNoteHeadersController.url(args, options),
    method: 'get',
})

GetCommissionNoteHeadersController.definition = {
    methods: ["get","head"],
    url: '/api/commission-note/{commission_note}/headers',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CommissionNote\GetCommissionNoteHeadersController::__invoke
* @see app/Http/Controllers/CommissionNote/GetCommissionNoteHeadersController.php
* @route '/api/commission-note/{commission_note}/headers'
*/
GetCommissionNoteHeadersController.url = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { commission_note: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { commission_note: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            commission_note: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        commission_note: typeof args.commission_note === 'object'
        ? args.commission_note.id
        : args.commission_note,
    }

    return GetCommissionNoteHeadersController.definition.url
            .replace('{commission_note}', parsedArgs.commission_note.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\GetCommissionNoteHeadersController::__invoke
* @see app/Http/Controllers/CommissionNote/GetCommissionNoteHeadersController.php
* @route '/api/commission-note/{commission_note}/headers'
*/
GetCommissionNoteHeadersController.get = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCommissionNoteHeadersController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CommissionNote\GetCommissionNoteHeadersController::__invoke
* @see app/Http/Controllers/CommissionNote/GetCommissionNoteHeadersController.php
* @route '/api/commission-note/{commission_note}/headers'
*/
GetCommissionNoteHeadersController.head = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCommissionNoteHeadersController.url(args, options),
    method: 'head',
})

export default GetCommissionNoteHeadersController